import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type ISemanticObjectAutoListItem} from '../schema';

/**
 * `getSemanticObjectAutoList` request params
 * (what is used to send to server)
 */
export type GetSemanticObjectAutoListRequestOptions = {
	query: string;
	id: number; // TODO: semantic object id
};

/**
 * `getSemanticObjectAutoList` request
 * (what gets sent to the server)
 */
export type GetSemanticObjectAutoListRequest = [
	GetSemanticObjectAutoListRequestOptions['query'],
	GetSemanticObjectAutoListRequestOptions['id'],
];

/**
 * `getSemanticObjectAutoList` response
 * (what comes back from the server)
 */
export type GetSemanticObjectAutoListResponse =
	SuccessResponse<GetSemanticObjectAutoListResult>;

/**
 * `getSemanticObjectAutoList` result
 * (what is utilized from the server response)
 */
export type GetSemanticObjectAutoListResult = ISemanticObjectAutoListItem[];

export const getSemanticObjectAutoListEndpoint = 'getSemanticObjectAutoList';

/**
 * Semantic object auto list
 */
export const getSemanticObjectAutoList = async (
	{id, query}: GetSemanticObjectAutoListRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetSemanticObjectAutoListRequest = [query, id];

	return client
		.post<GetSemanticObjectAutoListResponse>(
			getSemanticObjectAutoListEndpoint,
			requestParams,
			{signal},
		)
		.then((response) => response.data.result);
};

export default getSemanticObjectAutoList;
